import React, { useState, useEffect } from 'react';
import '../../styles/BackgroundSlider.scss';

const backgrounds = [
  '/images/slide/Slide0.jpg',
  '/images/slide/slide1.jpg',
  '/images/slide/slide2.jpg',
  '/images/slide/slide3.jpg',
  '/images/slide/slide4.jpg',
];

const BackgroundSlider: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % backgrounds.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="background-slider">
      {backgrounds.map((bg, index) => (
        <div
          key={bg}
          className={`slide ${index === currentIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${bg})` }}
        />
      ))}
    </div>
  );
};

export default BackgroundSlider; 